import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  
  // Force a re-render after component mounts
  useEffect(() => {
    
    // Clear any existing tokens if we've been explicitly redirected to login
    const currentPath = window.location.pathname;
    if (currentPath === '/login') {
      // Only clear if we're on the login page by direct navigation
      localStorage.removeItem('token');
    }
    
    // Check for error parameters in the URL
    const queryParams = new URLSearchParams(location.search);
    const errorType = queryParams.get('error');
    const errorMessage = queryParams.get('message');
    
    if (errorType) {
      let displayError = 'Authentication failed. Please try again.';
      
      if (errorType === 'unauthorized') {
        displayError = 'You are not authorized to access this application.';
      }
      
      if (errorMessage) {
        displayError += ` ${errorMessage}`;
      }
      
      setError(displayError);
      
      // Remove error from URL for better UX
      navigate('/login', { replace: true });
    }
  }, [location, navigate]);

  const handleMicrosoftLogin = () => {
    setIsLoading(true);
    setError('');
    
    // Get the API base URL from environment
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL

    // Direct to backend API SSO endpoint
    window.location.href = `${apiBaseUrl}/api/auth/sso/microsoft`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-600 via-brand-700 to-brand-800 flex items-center justify-center p-4">
      <div className="flex flex-col items-center">
        <div className="bg-white rounded-3xl shadow-2xl p-10 w-full max-w-md">
          <div className="mx-auto mb-8">
            <img src="/cartiga.svg" alt="Cartiga" className="w-16 h-16 mx-auto" />
          </div>

          <h2 className="text-2xl font-bold text-gray-900 text-center">
            Plaid Dashboard
          </h2>
          <p className="text-sm text-gray-500 text-center mt-2 mb-8">
            Sign in with your organization account
          </p>

          {error && (
            <div className="rounded-xl bg-red-50 border border-red-100 p-4 mb-6">
              <div className="text-sm text-red-700">{error}</div>
            </div>
          )}

          <button
            onClick={handleMicrosoftLogin}
            disabled={isLoading}
            className="w-full flex justify-center items-center py-3.5 px-4 bg-gray-50 border border-gray-200 rounded-full shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-100 hover:border-gray-300 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
          >
            <svg width="24" height="24" viewBox="0 0 21 21" className="mr-2">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            {isLoading ? 'Signing in...' : 'Sign in with Microsoft'}
          </button>

          <p className="text-xs text-gray-400 text-center mt-8">
            Plaid Integration Service
          </p>
        </div>

      </div>
    </div>
  );
};

export default Login;